<template>
	<div class="container-fluid MainContainer">
		<section class="container">
			<div class="mw-100 mb-3 extraTable">
				<table>
					<thead>
						<tr class="TabViewGrades__BQCRow">
							<router-link :to="{ name: 'BasicQualificationCourse' }"
								><th class="TabViewGrades__BQC">
									<img :src="textBasicQualificationCourse" />
								</th></router-link
								
							>
						</tr>
					</thead>
				</table>
				<img class="TabViewGrades__BQCArrows" :src="arrows" />
			</div>
			<div class="outer">
				<div class="mw-100 inner">
					<table>
						<thead>
							<tr>
								<th class="TabViewGradesEmpty"></th>
								<th class="text TabViewGrades_Grad1">
									<img :src="textGrad1" />
								</th>
								<th class="text TabViewGrades_Grad2">
									<img :src="textGrad2" />
								</th>
								<th class="text TabViewGrades_Grad3">
									<img :src="textGrad3" />
								</th>
								<th class="text TabViewGrades_Grad4">
									<img :src="textGrad4" />
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="fix">
									<img class="moduleName" :src="textPrefight" />
								</td>
								<td>
									<router-link :to="{ name: 'Grad1Prefight' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad1.lesson1.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad2Prefight' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad2.lesson1.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad3Prefight' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad4Prefight' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad4.lesson1.readMore.title'
											)
										}}
									</router-link>
								</td>
							</tr>
							<tr>
								<td class="fix">
									<img class="moduleName" :src="textInfight" />
								</td>
								<td>
									<router-link :to="{ name: 'Grad1Infight' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad1.lesson2.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad2Infight' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad2.lesson2.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad3Infight' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad3.lesson2.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad4Infight' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad4.lesson2.readMore.title'
											)
										}}
									</router-link>
								</td>
							</tr>
							<tr>
								<td class="fix">
									<img class="moduleName" :src="textWrestling" />
								</td>
								<td>
									<router-link :to="{ name: 'Grad1Wrestling' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad1.lesson3.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad2Wrestling' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad2.lesson3.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad3Wrestling' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad3.lesson3.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad4Wrestling' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad4.lesson3.readMore.title'
											)
										}}
									</router-link>
								</td>
							</tr>
							<tr>
								<td class="fix">
									<img class="moduleName" :src="textGrappling" />
								</td>
								<td>
									<router-link :to="{ name: 'Grad1Grappling' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad1.lesson4.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad2Grappling' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad2.lesson4.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad3Grappling' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad3.lesson4.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad4Grappling' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad4.lesson4.readMore.title'
											)
										}}
									</router-link>
								</td>
							</tr>
							<tr>
								<td class="fix">
									<img class="moduleName" :src="textWeapons" />
								</td>
								<td>
									<router-link :to="{ name: 'Grad1Weapons' }">
										{{ $t('navigationAusbildungsgrade.grade.grad1.lesson5.readMore.title') }} & {{ $t('navigationAusbildungsgrade.grade.grad1.lesson5a.readMore.title') }}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad2Weapons' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad2.lesson5.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad3Weapons' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad3.lesson5.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad4Weapons' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad4.lesson5.readMore.title'
											)
										}}
									</router-link>
								</td>
							</tr>
							<tr>
								<td rowspan="2">
									<img class="moduleNamePostfight" :src="textPostfight" />
								</td>
								<td>
									<router-link :to="{ name: 'Grad1Postfight1' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad1.lesson6.category1.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad2Postfight1' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad2.lesson6.category1.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad3Postfight1' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad3.lesson6.category1.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad4Postfight1' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad4.lesson6.category1.readMore.title'
											)
										}}
									</router-link>
								</td>
							</tr>
							<tr>
								<td>
									<router-link :to="{ name: 'Grad1Postfight2' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad1.lesson6.category2.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad1Postfight2' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad2.lesson6.category2.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad1Postfight2' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad3.lesson6.category2.readMore.title'
											)
										}}
									</router-link>
								</td>
								<td>
									<router-link :to="{ name: 'Grad1Postfight2' }">
										{{
											$t(
												'navigationAusbildungsgrade.grade.grad4.lesson6.category2.readMore.title'
											)
										}}
									</router-link>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import textWrestling from '@/assets/moduleTableText/textWrestling.png'
import textPrefight from '@/assets/moduleTableText/textPrefight.png'
import textInfight from '@/assets/moduleTableText/textInfight.png'
import textGrappling from '@/assets/moduleTableText/textGrappling.png'
import textWeapons from '@/assets/moduleTableText/textWeapons.png'
import textPostfight from '@/assets/moduleTableText/textPostfight.png'
import textGrad1 from '@/assets/moduleTableText/textGrad1.png'
import textGrad2 from '@/assets/moduleTableText/textGrad2.png'
import textGrad3 from '@/assets/moduleTableText/textGrad3.png'
import textGrad4 from '@/assets/moduleTableText/textGrad4.png'
import arrows from '@/assets/moduleTableText/arrows.png'
import textBasicQualificationCourse from '@/assets/moduleTableText/textBasicQualificationCourse.png'
import systemMixin from '@/views/system/systemMixin.js'

export default {
	name: 'TabViewGrades',
	data() {
		return {
			textPostfight,
			textWeapons,
			textGrappling,
			textInfight,
			textPrefight,
			textWrestling,
			textGrad4,
			textGrad3,
			textGrad2,
			textGrad1,
			arrows,
			textBasicQualificationCourse
		}
	},
	mixins: [systemMixin]
}
</script>

<style scoped lang="styl">

.TabViewGrades_Grad1 img,
.TabViewGrades_Grad2 img,
.TabViewGrades_Grad3 img,
.TabViewGrades_Grad4 img {
	width: 173px;
}

 .moduleName {
	    width: 180px;
    }
    .moduleNamePostfight {
	    width: auto;
   		height: 39px;
    }

.TabViewGrades__BQCArrows {
	height: 35px;
	width: 100%;
}

.TabViewGrades__BQC img {
	width: auto;
	height: 37px;
}
@media only screen and (min-width: 1365px) {
	.moduleNamePostfight {
		height: 31px;
	}
}
@media only screen and (max-width: 550px) {
	.TabViewGrades__BQC img {
		height: 32px;
	}
}
@media only screen and (min-width: 600px) {
	.TabViewGrades__BQC {
		width: 70vw;
	}
}
@media only screen and (min-width: 800px) {
	.TabViewGrades__BQC {
		width: 80vw;
	}
	.TabViewGrades__BQC img {
		width: auto;
		height: 32px;
	}
}
.TabViewGrades__BQC {
	transition: transform .2s;
	color: rgba(255,255,255,0.5);
	border-color: rgba(255,255,255,0.5);
}

.TabViewGrades__BQC:hover {
    transform: scale(1.04);
    color: red;
    background-color: rgba(11,38,46,0.8);
	cursor: pointer;
}

th.TabViewGrades__BQC--empty {
 	width: 16.2rem;
	border-top: none;
    border-left: none;
	border-bottom: none;
}
.TabViewGrades__BQCRow {
    border-bottom: none;
}

tr td:first-child {
    transition: none;
	cursor: auto;
}

tr td:first-child {
    border-left: 1px solid rgba(255,255,255,0.7);
}

table {
    position: relative;
}

.MainContainer {
    background-color: rgba(0, 0, 0, 0.6);
    outline: none;
    padding: 35px 0;
}


tr, th {
  border-bottom: 1px solid rgba(255,255,255,0.7);
}

th {
    color: #fff;
    white-space: nowrap;
    text-transform: uppercase;
    text-align: center;
    padding: 0.5em 1em;
    border-right: 1px solid rgba(255,255,255,0.7);
    border-top: 1px solid rgba(255,255,255,0.7);
}

.TabViewGradesEmpty {
    border-left: 1px solid rgba(255,255,255,0.7);
}

td {
  text-align: center;
  padding: 0.5em 1em;
  border-right: 1px solid rgba(255,255,255,0.7);
  transition: transform .2s;
  cursor: pointer;
}

td a {
	color: #fff;
}

td:hover {
    transform: scale(1.2);
    background-color: rgba(11,38,46,0.8);
	a {
		color: red;
	}
}

td a:hover {
	color: red;
	text-decoration: none;
}

td:first-child:hover {
    transform: none;
    background-color: transparent;
}

.fix img {
	width: 75%;
}
</style>
